import { render, staticRenderFns } from "./prdin_ww.vue?vue&type=template&id=b63a8fb0&scoped=true&"
import script from "./prdin_ww.vue?vue&type=script&lang=js&"
export * from "./prdin_ww.vue?vue&type=script&lang=js&"
import style0 from "./prdin_ww.vue?vue&type=style&index=0&id=b63a8fb0&scoped=true&lang=less&"
import style1 from "./prdin_ww.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63a8fb0",
  null
  
)

export default component.exports